export default {
    positionIDStringMap: {
        1: 'QB',
        2: 'RB',
        3: 'WR',
        4: 'TE',
        5: 'PK',
        16: 'DST',
    },

    // change this order after champion is determined
    managerList: [
        'Taylor', 
        'Kieffer', 
        'Scott', 
        'Conor', 
        'Tench', 
        'Davis',
        'Mike', 
        'Dan', 
        'Tommy',
        'Steve',
        'Aidan', 
        'Zane', 
    ],

    positions: ['QB','RB','WR','TE','K','DST'],

    currentSeason: 2026,
    eligablePayoutYears: [2025, 2026, 2027],
    eligbleFAABYears: [2025, 2026, 2027],
    allDraftYears: [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030],
};